<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormUser @submit="submit" :title="'Add User'" :form="{}"></FormUser>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import FormUser from '@/views/admin/user/FormUser'

export default {
  name: 'adduser',
  components: {
    FormUser
  },
  methods: {
    submit (form) {
      let scope = this; 

      form.user = scope.$store.getters.currentUser.id
      form.isTester = false;

      axios.post(process.env.VUE_APP_API + '/user', form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.$router.push('/admin/users/list')
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
